import
  React
from 'react';

import {
  Text,
  VContainer
} from '@vodacom/web-common';

import {
 CustomColors
} from '../../constants';

export const SearchPageError = (props) => {

  return (

    <VContainer
      backgroundColor={CustomColors.White}
      boxShadow={`0px 5px 15px 0px ${CustomColors.TransparentBlack1}`}
      padding={'16px 23px'}
      margin={'0 7px 16px'}>

      <Text
        color={CustomColors.Grey11}
        fontWeight={'bold'}
        fontSize={'20px'}
        padding={'0 0 8px'}>

        {props.title}
      </Text>

      <Text
        color={CustomColors.Grey9}
        fontSize={'16px'}
        padding={'0 0 8px'}>

        {'Please try again.'}
      </Text>

    </VContainer>
  );
};